var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"balance-fm"},[_c('span',{staticClass:"font-weight-bold"},[(_vm.dollar)?_c('span',[_vm._v("$ ")]):_vm._e(),_vm._v(_vm._s(_vm.computedInteger))]),_c('span',{staticClass:"decimal"},[_vm._v(_vm._s(_vm.computedDecimal))])])
}
var staticRenderFns = []

export { render, staticRenderFns }